import React, { Component } from 'react';
import M from 'materialize-css';
import { getConfigPopupLogin } from '../utils';


class PopupLogin extends Component {

    state = {
        config: false
    }

    componentDidMount() {
        M.Modal.init(document.getElementById('modalPopupLogin'));
        window.addEventListener('mostrarPopupLogin', this.mostrarPopup);
    }

    componentWillUnmount() {
        window.removeEventListener('mostrarPopupLogin', this.mostrarPopup);
    }

    mostrarPopup = async () => {
        const config = await getConfigPopupLogin();

        if (config) {
            this.setState({ config }, () => {
                M.Modal.getInstance(document.getElementById('modalPopupLogin')).open();
            });
        }
    }

    render() {
        let { config } = this.state;

        let imagen = config ?
            <img src={config.imagen_url} alt="Aviso Valmex" className="responsive-img popupLoginImg" />
            : null;

        return (
            <div id="modalPopupLogin" className="modal modalPopupLogin">
                <div className="modal-content">
                    <i className='material-icons modal-close popupLoginClose'>clear</i>
                    {
                        config && config.url_destino ?
                            <a href={config.url_destino} target="_blank" rel="noopener noreferrer">{imagen}</a>
                            : imagen
                    }
                </div>
            </div>
        )
    }

}

export default PopupLogin;
